import {useSelector} from 'react-redux';

import {getIsSettingHolderRelated} from '@/services/device/deviceSettingsService';
import {selectDeviceType} from '@/state/selectors/device';

const useIsSettingHolderRelated = (settingType) => {
    const deviceType = useSelector(selectDeviceType);
    const result = getIsSettingHolderRelated(deviceType, settingType);

    return result;
};

export default useIsSettingHolderRelated;
